import { companyDetailTypes } from './actions'

const initialState = {
    isFetching: false,
    data: {},
    currentUser: null
}

export function companyDetails(state = initialState, action) {
    let existing = null


    switch(action.type) {

        case companyDetailTypes.REQUEST_UPDATE:
        case companyDetailTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case companyDetailTypes.RECEIVE:
            state = {...state, isFetching: false};
            state.data = action.data;
            
            if(action.data.UserList.filter(f => f.currentUser).length >= 1) {
                state.currentUser = action.data.UserList.filter(f => f.currentUser)[0]
            }

            return state;
        case companyDetailTypes.RECEIVE_UPDATE:
            return {
                ...state,
                isFetching: false,
                data: {
                    ...state.data,
                    ...(action.data && action.data.Customer ? action.data : {})
                }
            }
        default:
            return state
    }
}
